export enum RateMap {
  "1.0x" = "1X",
  "2.0x" = "2X",
  "4.0x" = "4X",
  "8.0x" = "8X",
  "10.0x" = "10X",
}
